export const NAVIGATE_TO_CD = 'CD';
export const NAVIGATE_TO_BAA = 'BAA';
export const NAVIGATE_TO_BD = 'BD';
export const NAVIGATE_TO_SOURCE = 'source';
export const API_VERSION = '1.0.0';
export const NAVIGATE_TO_CD_REVIEW = 'CD_REVIEW';
export const NAVIGATE_TO_BD_REVIEW = 'BD_REVIEW';
export const NAVIGATE_TO_EXIT = 'NAVIGATE_TO_EXIT';
export const DEFAULT_BANK = 'cb';
export const BANK_ID_CYB = 'cyb';
//Service method constants
export const METHOD_GET = 'GET';
export const METHOD_POST = 'POST';
export const METHOD_PUT = 'PUT';

export const CASE_SUBTYPE = 'caseType';
export const CASE_TYPE_NTB = 'ntb';
export const CASE_TYPE_EXISTING = 'existing';
export const CASE_SUBTYPE_MULTIPARTY = 'MultiParty';

export const ACCOUNT_DETAILS = 'business-accounts';
export const CUSTOMER_DETAILS = 'customer-details';
export const BUSINESS_DETAILS = 'business-details';
export const ACCESS_TOKEN = 'access_token';
export const BANK_ID = 'bank_id';
export const BRAND_ID = 'brand_id';
export const REDIRECT_URI = 'redirect_uri';
export const SHOW_PAGE_TYPE = 'show';
export const BUSINESS_TYPE = 'business_type';
export const BUSINESS_TYPE_FIELD = 'businessTypeField';
export const USERNAME_PASSWORD = 'username_password';
export const CASE_ID = 'case_id';
export const CUSTOMER_UUID = 'customer_uuid';

// Application routes
export const ROUTE_INITIAL_QUESTION_PAGE = '/initialQuestions';
export const ROUTE_PERSONAL_INFO_PAGE = '/personalInformation';
export const ROUTE_BUSINESS_TYPE_PAGE = '/businessType';
export const ROUTE_USERNAME_PASSWORD_PAGE = '/usernamePassword';
export const ROUTE_ACCOUNT_DETAILS_PAGE = '/accountDetails';
export const ROUTE_ADDITIONAL_PRODUCT_PAGE = '/additionalProducts';
export const ROUTE_REVIEW_PAGE = '/reviewSections';
export const ROUTE_INFO_SECTION = '/importantInformationSection';
export const ROUTE_PENDING_STATEMENTS_PAGE = '/pendingStatementsSection';
export const ROUTE_PENDING_STATEMENTS_FAIL_PAGE = '/pendingStatementsSectionFail';
export const ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE = '/creditCheckDeferredSection';
export const ROUTE_DEFERRED_PAGE = '/deferredSection';
export const ROUTE_CHECK_IDENTITY_PAGE = '/checkIdentitySection';
export const ROUTE_SECURITY_CHECKS_PAGE = '/securityChecks';
export const ROUTE_APP_BOOTSTRAP = '/bootstrapComponent';
export const ROUTE_BUSINESS_MANDATE_PAGE = '/businessMandate';
export const ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE = '/signatoriesAndShareholders';
export const ROUTE_SIGNIFICANT_PEOPLE_PAGE = '/significantPeople';
export const ROUTE_DOCUMENT_VERSION_PAGE = '/documentVersion';
export const DECLINE = '/decline';
export const ROUTE_OPEN_BUSINESS_ACCOUNT_PAGE = '/openBusinessAccount';
export const ROUTE_ALT_BUSINESS_ACCOUNT_PAGE = '/openAlternateBusinessAccount';
export const LETTER_CODE = '/enterAuthorisationCode';
export const ROUTE_ENTER_LINK_CODE = '/enterLinkCode';
export const OFFER_PAGE = '/offerSection';
export const ROUTE_OFFER_SECTION = '/offer';
export const PAYMENT_TYPE_CHECKBOX = 'payment_type_checkbox';
export const INITIAL_INFO = 'initial_info';
export const MANDATE_INFO = 'business_mandate';
export const CHECK_IDENTITY_INFO = 'check_identity_info';
export const SECURITY_CHECKS_INFO = 'security_checks_info';
export const PERSONAL_INFO = 'personal_info';
export const ADDITIONAL_PRODUCT = 'additional_product';
export const REDIRECT_ADDITIONAL_PRODUCT_PAGE = 'REDIRECT_ADDITIONAL_PRODUCT_PAGE';
export const CREATE_CUSTOMERS_CASE = 'FETCH_CUSTOMERS';
export const CREATE_CUSTOMERS_CASE_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const CREATE_CUSTOMERS_CASE_FAILED = 'FETCH_CUSTOMERS_FAILED';
export const UPDATE_DETAILS_CASE = 'UPDATE_DETAILS_CASE';
export const UPDATE_DETAILS_CASE_SUCCESS = 'UPDATE_DETAILS_CASE_SUCCESS';
export const UPDATE_DETAILS_CASE_FAILED = 'UPDATE_DETAILS_CASE_FAILED';
export const REDIRECT_TO_ACCOUNT_DETAILS = 'REDIRECT_TO_ACCOUNT_DETAILS';
export const REDIRECT_TO_PAGE = 'REDIRECT_TO_PAGE';
export const SAVE_QUERY_STRING_VALUES = 'SAVE_QUERY_STRING_VALUES';
export const QUERY_PARMAS = 'query_parmas';
export const ACCOUND_DETAILS = 'account_details';
export const BDD_REVIEW_PAGE = '/businessDetailsAll';
export const QUERY_PARAM_CONTENTS = 'query_params';
export const OFFER = 'offer';
export const BUSINESS_CURRENT_ACCOUNT = 'Business Current Account';
export const BDD_ABOUT_YOUR_BUSINESS = '/aboutBusiness';
export const BUSINESS_TYPE_PAGE = 'business_type_page';
export const ENTER_AUTH_PAGE = 'enter_auth_page';
export const ENTER_LINK_CODE_PAGE = 'enter_link_code_page';
export const OPEN_BUSINESS_ACCOUNT_PAGE = 'open_business_account_page';
export const ALT_BUSINESS_ACCOUNT_PAGE = 'alt_business_account_page';
export const SCREEN_SHOT_MIME_TYPE = 'image/jpeg';
export const SCREEN_SHOT_QUALITY = 0.5;
export const API_STRING_FIELD_MAX_LENGTH = 100000;
export const INFO_FLAG = 'INFO_FLAG';
export const GET_NEXTCALL = 'GET_NEXTCALL';
export const GET_NEXTCALL_SUCCESS = 'GET_NEXTCALL_SUCCESS';
export const GET_NEXTCALL_FAILED = 'GET_NEXTCALL_FAILED';
export const INITIAL_QUESTIONS_TMSP = 'timestamp_initial_questions';
export const PDF_DOWNLOAD_URL = 'staticProductContentUrl';
export const WER_REFEENCE_PDFS = 'web_reference_pdf';
export const WEB_REF_FAIR_PROCESSING = 'VMFairProcessingNotice.pdf';
export const WEB_BUSINESS_TERMS_CONDITIONS = 'VMTandCs.pdf';
export const WEB_BUSINESS_TARIFF_GUIDE = 'VMTariff.pdf';
export const WEB_REF_DGS = 'DGS';
export const WEB_REF_BUS_DATA_PROTECTION = 'businessDataProtection';
export const WEB_REF_SWITCH_PAYMENT = 'VMPaymentTransferGuide.pdf';
export const WEB_REF_SWITCH_PAYMENT_FULL = 'VMSwitchServicePack-CASSSP.pdf';
export const WEB_REF_ONLINE_SERVICE_TARIFF = 'VMBusinessIBTariff.pdf';
export const WEB_REF_DIGITAL_BANKING_BUSINESS_TERMS = 'VMBusinessDigitalTandCs.pdf';

export const WEB_FSCS_INFORMATION = 'VMFSCSInformationSheet.pdf';
export const OFFER_CASE_ID = 'caseId';
export const AUTH_PAGE_KEY = 'confirmcode';
export const CONFIRM_AUTH_CODE = 'confirmauthcode';
export const ROUTE_ALMOST_THERE_PAGE = '/almostThere';
export const ROUTE_SWITCH_BUSINESS_PAGE = '/switchBusiness';
export const ROUTE_OLD_ACCOUNT_DETAILS_PAGE = '/oldAccountDetails';
export const ROUTE_OLD_SIGNATORIES_PAGE = '/oldSignatories';
export const ROUTE_OLD_ADD_SIGNATORY_PAGE = '/oldAddSignatory';
export const ROUTE_SWITCH_DATE_PAGE = '/switchDate';
export const ROUTE_APPLICATION_COMPLETE_PAGE = '/applicationComplete';
export const ROUTE_BEGIN_YOUR_APPLICATION_PAGE = '/beginApplicationSection';
export const ROUTE_ABOUT_YOUR_APPLICATION_PAGE = '/aboutYourApplicationSection';
export const ALMOST_THERE_INFO = 'almost_there_info';
export const SWITCH_BUSINESS_INFO = 'switch_business_info';
export const OLD_ACCOUNT_DETAILS_INFO = 'old_account_details__info';
export const SWITCH_DATE_INFO = 'switch_date_info';
export const APPLICATION_COMPLETE_INFO = 'application_complete_info';
export const BEGIN_YOUR_APPLICATION_PAGE_INFO = 'begin_your_application_page_info';
export const ABOUT_YOUR_APPLICATION_PAGE_INFO = 'about_your_application_page_info';
export const ROUTE_APPLICATION_SUBMISSION_PAGE = '/submission';
export const ROUTE_INFORMATIVE_PAGE = '/informative';

export const DECLINE_OFFERS = [
  'applicationrejected',
  'creditcheckdeclined',
  'cancelled',
  'idcheckfail'
];
export const EXISTING_NEW_BUSINESS = 'existing/newbusiness';
export const NAVIGATE_TO_SUBMISSION_PAGE = 'navigate_to_submission';
export const ROUTE_TECH_ERROR = '/technicalError';
export const SET_UP_IN_PROGRESS_ERROR = '/setupInProgressError';
export const ROUTE_PRIMARY_APPLICANT_WAITING = '/primaryApplicantWaiting';
export const ROUTE_SECONDARY_APPLICANT_WAITING = '/secondaryApplicantWaiting';
export const BUSINESS_ACCOUNT_OPENING = 'BUSINESS_ACCOUNT_OPENING';
export const FULLMENT_INPROGRESS = 'fulfillmentinprogress';
export const GET_NEXT_CHALLANGE = 'challenge';
export const GET_NEXT_CREDIT_CHECK = 'creditcheckreferred';
export const GET_NEXT_SETUP_IN_PROGRESS_ERROR = 'productsetupinprogress';
export const GET_NEXT_APP_EXPIRE = 'applicationexpired';
export const GET_NEXT_APPL_REJ = 'applicationrejected';
export const GET_NEXT_CREDIT_CHECK_DEC = 'creditcheckdeclined';
export const GET_NEXT_CREDIT_CHECK_CANCEL = 'cancelled';
export const NAVIGATE_TO_IMP_INFO = 'IMP_INFO';
export const PRODUCT_NAME = 'productName';
export const SOURCE_ID = 'sourceId';
export const ROUTE_IDV_QUESTION_PAGE = '/IDVQuestions';
export const GET_NEXT_DEF = 'deferred';
export const GET_NEXT_CREDIT_CHECK_DEF = 'creditcheckdeferred';
export const GET_NEXT_CREDIT_CHECK_REF_NOMATCH = 'creditcheckreferrednomatch';
export const GET_NEXT_PENDING_STATEMENTS = 'pendingstatements';
export const GET_NEXT_PENDING_STATEMENTS_FAIL = 'pendingstatements3dfail';
export const SAVE_AND_RESUME_CAPTURE = 'capture';
export const ROUTE_PERSONAL_DETAILS_PAGE = '/personDetailsSection';
export const DATE_FIELD = 'dateField';
export const MONTH_FIELD = 'monthField';
export const YEAR_FIELD = 'yearField';
export const PERSON_DETAILS = 'person_details';
export const TYPE_UK_ADDRESS = 'ukAddress';
export const ADDRESS_DURATION_LIMIT = 3;
export const MOVE_TO_DATE = 'MoveToDate';
export const ADDRESS_LIST = 'addressList';
export const OFFICER_DETAILS = 'officer_details';
export const DATE_MOVE_SUFFIX = 'DateMove';
export const GET_NEXT_APPLICANT_WAITING_REFER = 'awaitapplicant';
export const CREATE_CASE_ERROR = 'create_case_error';
export const APPLICATION_URIS = 'applicationURIs';
export const AUTHENTICATION_KEY = 'AUTHENTICATION';
export const BUSINESS_ACCOUNTS = 'BUSINESS_ACCOUNTS';
export const ROUTE_TO_INCORRECT_LINK_CODE = '/incorrectLinkCode';
export const LINK_CODE_KEY = 'linkCode';
export const LINK_CODE_DETAIL = 'link_code_detail';
export const CASE_DETAIL_KEY = 'caseData';
export const NAVIGATION_KEY = 'navigation';
export const NAVIGATION_BACK = 'back';
export const NAVIGATION_EXIT = 'exit';
export const BROWSER_REDIRECT_URL = 'browserRedirectUrl';
export const CSS_LOADER_DELAY = 500;
export const SELECTED_ADDRESS = 'SelectedAddress';
export const ID_CHECK_CANT_BE_DONE = 'idcheckcannotbedone';
export const SIGNATORIES_SHAREHOLDER_DATA = 'signatories_shareholder';
export const RESUME_CASE_KEY = 'resumeCases';
export const PRIMARY_BANK_ID = 'pBankId';

export const ANALYTICS_ERROR = {
  FETCH_CASE_FAILED: 'Failed to load case details.',
  FETCH_CONFIG_FAILED: 'Failed to load config.',
  FETCH_CUSTOMERBYID_FAILED: 'Failed to load customer by id.',
  REQUEST_TOKEN_FAILED: 'No token recieved from API.'
};

export const SECONDARY_APPLICANT_ON_HOLD_TASK = 'secondaryonholdtask';

export const PRIMARY_APPLICANT = 'PRIMARY_APPLICANT';
export const RADIO_VALUE_YES = 'Y';
export const RADIO_VALUE_NO = 'N';
export const OFIICER_KEY = 'OFFICER_KEY';
export const APPLICANT_FLOW = 'applicantFlow';
export const GET_CUSTOMER_KEY = 'GET_CUSTOMER_KEY';
export const GET_BUSINESS_CUSTOMER_KEY = 'GET_BUSINESS_CUSTOMER_KEY';

export const SORT_FIELD1 = 'sortField1';
export const SORT_FIELD2 = 'sortField2';
export const SORT_FIELD3 = 'sortField3';
export const ROUTE_TO_IDV_CHALLENGE_ERROR = '/idv_challenge_error';
export const LINK_CODE_RESUME_FLOW = 'linkCodeResume';
export const OLD_SIGNATORIES_KEYS = 'old_signatories';
export const OTHER_KEY = 'Other';
export const LIMITED_LIB_PARTNERSHIP = 'limited liability partnership';
export const SOLE_TRADER = 'sole trader';
export const LIMITED_COMPANY_ONE_DIRECTOR = 'Limited company';
export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const DATE_FORMAT = 'DD-MM-YYYY';
export const RESUME_KEY = 'resume';
export const TYPE_KEY = 'type';
export const ROUTE_RESUME_PAGE = '/resumeApplication';
export const SEND_PAYMENTS = 'send';
export const RECEIVE_PAYMENTS = 'receive';
